<template lang="pug">
action-bar(
  :entity="entity"
  @refresh="$emit('refresh')"
  @perform="opts => $emit('perform', opts)"
)
  template(#right)

    //- v-tooltip(bottom)
    //-   template(#activator="{ on, attrs }")
    //-     v-btn.mx-1(
    //-       icon
    //-       v-bind="attrs"
    //-       v-on="on"
    //-       @click="$emit('refresh')"
    //-     )
    //-       v-icon mdi-play-circle-outline
    //-   span
    //-     span.text-md.font-weight-medium Iniciar Todos os Serviços
    //-     br
    //-     span.font-weight-light Inicia todos os serviços ainda não iniciados.

    //- BOTÃO DE ATUALIZAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn.mx-1(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('refresh')"
        )
          v-icon mdi-refresh
      span
        span.text-md.font-weight-medium Atualizar
        br
        span.font-weight-light Sincroniza os dados da página com o servidor de dados.

    //- v-btn(small icon)
    //-   v-icon mdi-dots-vertical

</template>

<script>
import ActionBar from '@/components/commons/action-bar/ActionBar'

export default {
  components: {
    ActionBar,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,
  },

  data: () => ({
  }),

  computed: {
  },
}
</script>